import { createFileRoute } from "@tanstack/react-router";
import IvyLeagueStudentDepression from "@/pages/articles/IvyLeagueStudentDepression";
export const Route = createFileRoute(
  "/your-child-got-into-an-ivy-what-nobody-warned-you-about",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ivy League Mental Health | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Your child got into an Ivy League school. Learn about the mental health risks nobody warned you about and treatment options in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Ivy League Mental Health | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Your child got into an Ivy League school. Learn about the mental health risks nobody warned you about and treatment options in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/your-child-got-into-an-ivy-what-nobody-warned-you-about",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/your-child-got-into-an-ivy-what-nobody-warned-you-about",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IvyLeagueStudentDepression />;
}
